import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import VisaForm2 from "./VisaForm2"
import { notify } from "react-notify-toast"
import { parseDate } from "../../Helper"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
// import { notify } from "react-notify-toast";
// import { parseDate } from "../../Helper";

class Visa2 extends React.Component {
  state = {
    id: this.props.user._id,
    visa_url: this.props.user.visa_url,
    visa_filename: this.props.user.visa_filename,
    issuing_office: this.props.user.issuing_office, // Issuing visa country
    visa_status: this.props.user.visa_status,
    visa_type: this.props.user.visa_type,
    visa_type_other: "",
    visa_expiry: parseDate(this.props.user.visa_expiry),
    visa_application_number: this.props.user.visa_application_number,
    visa_verification_status: this.props.user.visa_verification_status,
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleDateChange = (date) => {
    this.setState({ visa_expiry: date })
  }

  handleRadioChange = (e) => {
    this.setState({ visa_status: e.target.title })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = [
      "citizen",
      "visa_holder",
      "visa_application_number",
      "visa_type",
      "visa_type_other",
      "issuing_office",
      "visa_expiry",
    ]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      console.log(field, input.checkValidity())
      if (this.state.visa_status !== "I am Australian Citizen") {
        if (!input.reportValidity()) {
          errors = true
          break
        }
      }
    }

    if (errors) {
      notify.hide();
      notify.show("Please complete the missing fields.")
      errors = true
    }

    if (!errors) {
      notify.hide();
      this.props.updatePersonalDetails({
        visa_url: this.state.visa_url,
        visa_filename: this.state.visa_filename,
        issuing_office: this.state.issuing_office,
        visa_status: this.state.visa_status,
        visa_type:
          this.state.visa_type === "Other"
            ? this.state.visa_type_other
            : this.state.visa_type,
        visa_expiry: this.state.visa_expiry,
        visa_application_number: this.state.visa_application_number,
      })
    }
  }

  getTabs = () => {
    const tabs = [
      {
        pathname: "/personalid",
        text: "Personal ID",
      },
      {
        pathname: "/visa",
        text: "Visa Details",
        active: true,
      },
      {
        pathname: "/policecheck",
        text: "Police Check (Opt.)",
      },
      {
        pathname: "/wwcc",
        text: "WWCC (Optional)",
      },
      {
        pathname: "/usiCheck",
        text: "USI Check (Opt.)",
      }
    ]

    if (this.props.user?.is_elt) {
      tabs.push({
        pathname: "/uploadPayLevel",
        text: "Pay Level Evidence",
      })
    }

    if (this.props.user?.is_childhood_teacher) {
      tabs.push({
        pathname: "/ececcheck",
        text: "First AID",
      })
    }

    return tabs
  }

  tabs = this.getTabs()

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Identification"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <VisaForm2
            handleStateChange={this.handleStateChange}
            handleDateChange={this.handleDateChange}
            handleFormFieldChange={this.handleFormFieldChange}
            handleRadioChange={this.handleRadioChange}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Visa2)
